export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_41-2d48a1ad626f5098f6a1f5c7f3718788.jpg";